import styled from 'styled-components';
import { Paper, Button } from '@mui/material';
import { text } from 'stream/consumers';

export const ChatWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background-color: transparent;
    padding: 1rem 0;
    box-sizing: border-box;
`;

export const MessageBubble = styled('div')<{ isUser?: boolean }>`
  margin: 0.5rem;
  padding: 0.75rem;
  max-width: 80%;
  color: ${({theme, isUser }) => isUser ? theme.colors.white : theme.colors.textColor } !important;
  p {
    color: ${({theme, isUser }) => isUser ? theme.colors.white : theme.colors.textColor } !important;
  }
  min-width: ${({isUser}) => isUser && '84.136px'};
  min-height: ${({isUser}) => isUser && '52px'};
  background-color: ${props => props.isUser ? props.theme.colors.darkBlueBtn : 'rgba(255, 255, 255, 0.05)'};
  border-radius: 12px;
  border-top-right-radius: ${props => props.isUser ? '4px' : '12px'};
  border-top-left-radius: ${props => !props.isUser ? '4px' : '12px'};
`;

// ...existing code...

export const ChatInputWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 1px solid ${({theme}) => theme.colors.divider};
  background: transparent;
  box-sizing: border-box;
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  color: ${({theme}) => theme.colors.textColor};
  font-size: ${({theme}) => theme.font.medium};
  background: transparent;
  width: 100%;
  padding: 8px 0;
  
  &:focus {
    outline: none;
  }
  
  &::placeholder {
    color: ${({theme}) => theme.colors.textColor};
    opacity: 0.7;
  }
`;

export const MessageContainer = styled.div<{ isUser?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 16px 1rem;
  justify-content: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  flex-direction: ${props => props.isUser ? 'row-reverse' : 'row'};
`;

export const Avatar = styled.div<{ isUser?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.isUser ? props.theme.colors.darkBlueBtn : props.theme.colors.darkBlueBtn};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: white;
`;

export const MessageContent = styled('div')<{ isUser?: boolean }>`
  display: flex;
  justify-content: end;
  ${({isUser}) => !isUser && "flex-direction: column"};
  flex: 1;
`;

export const MessageActions = styled.div`
  display: flex;
  margin-top: 0.25rem;
  justify-content: flex-start;
  color: ${({theme}) => theme.colors.textColor};

  svg {
    width: 15px;
  }
  
  button {
    margin: 0 0.25rem;
    padding: 0;
  }
`;

export const ActionButton = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.colors.buttonBackground};
    color: white;
    border-radius: 25px;
    padding: 8px 24px;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
    box-shadow: ${({ theme }) => theme.shadows.button};
    margin: 0 8px;
    min-width: 120px;
    
    &:hover {
      background-color: ${({ theme }) => theme.colors.highlight2};
    }
    
    &.disabled {
      background-color: ${({ theme }) => theme.colors.lightGrey};
      color: ${({ theme }) => theme.colors.textDisabledColor};
    }
  }
`;

